import {
    SNACKBAR_MSG
} from '../types';

// const ss = {txt:'Oh! Se ha perdido la conexión! 😱', rest:{ variant: 'warning', anchorOrigin: {vertical: 'top', horizontal: 'center'}}}
export function mostrarSnack(txt, rest = null) {
    return (dispatch) => {
        console.log(txt, rest)
        dispatch({
            type: SNACKBAR_MSG,
            payload: {
                txt,
                rest
            }
        });
    }
}